import React from "react";
import styles from "./TireSizeTextBlock.module.scss";
interface TireSizeTextBlockProps {
  tyreCode: string;
  points: string[];
  className?: string;
}

export default function TireSizeTextBlock({
  tyreCode,
  points,
  className,
}: TireSizeTextBlockProps) {
  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.title}>
        <span className={styles.code}>{tyreCode}</span> is the tyre size code
        which means,
      </div>
      <ul className={styles.points}>
        {points && points.map((point, index) => (
          <li key={index}>{point}</li>
        ))}
      </ul>
    </div>
  );
}
